export default function getWeatherDescription(code: number | string): string {
  // Accept both numeric and string inputs
  const n = typeof code === 'string' ? parseInt(code, 10) : code;

  /* ---------- 1. OpenWeatherMap codes ---------- */
  const owmMap: Record<number, string> = {
    // Thunderstorm
    200: "Thunderstorm with light rain",
    201: "Thunderstorm with rain",
    202: "Thunderstorm with heavy rain",
    210: "Light thunderstorm",
    211: "Thunderstorm",
    212: "Heavy thunderstorm",
    221: "Ragged thunderstorm",
    230: "Thunderstorm with light drizzle",
    231: "Thunderstorm with drizzle",
    232: "Thunderstorm with heavy drizzle",

    // Drizzle
    300: "Light drizzle",
    301: "Drizzle",
    302: "Heavy drizzle",
    310: "Light drizzle rain",
    311: "Drizzle rain",
    312: "Heavy drizzle rain",
    313: "Shower drizzle",
    314: "Heavy shower drizzle",
    321: "Shower drizzle",

    // Rain
    500: "Light rain",
    501: "Moderate rain",
    502: "Heavy rain",
    503: "Very heavy rain",
    504: "Extreme rain",
    511: "Freezing rain",
    520: "Light shower rain",
    521: "Shower rain",
    522: "Heavy shower rain",
    531: "Ragged shower rain",

    // Snow
    600: "Light snow",
    601: "Snow",
    602: "Heavy snow",
    611: "Sleet",
    612: "Light shower sleet",
    613: "Shower sleet",
    615: "Light rain and snow",
    616: "Rain and snow",
    620: "Light shower snow",
    621: "Shower snow",
    622: "Heavy shower snow",

    // Atmosphere
    701: "Mist",
    711: "Smoke",
    721: "Haze",
    731: "Dust whirls",
    741: "Fog",
    751: "Sand",
    761: "Dust",
    762: "Volcanic ash",
    771: "Squalls",
    781: "Tornado",

    // Clear / clouds
    800: "Clear sky",
    801: "Few clouds",
    802: "Scattered clouds",
    803: "Broken clouds",
    804: "Overcast clouds",
  };

  /* ---------- 2. WMO codes (what you had) ---------- */
  const wmoMap: Record<number, string> = {
    0: "Clear sky",
    1: "Mainly clear",
    2: "Partly cloudy",
    3: "Overcast",
    45: "Fog",
    48: "Depositing rime fog",
    51: "Light drizzle",
    53: "Moderate drizzle",
    55: "Dense drizzle",
    56: "Light freezing drizzle",
    57: "Dense freezing drizzle",
    61: "Slight rain",
    63: "Moderate rain",
    65: "Heavy rain",
    66: "Light freezing rain",
    67: "Heavy freezing rain",
    71: "Slight snow",
    73: "Moderate snow",
    75: "Heavy snow",
    77: "Snow grains",
    80: "Slight rain showers",
    81: "Moderate rain showers",
    82: "Violent rain showers",
    85: "Slight snow showers",
    86: "Heavy snow showers",
    95: "Thunderstorm (slight/moderate)",
    96: "Thunderstorm with slight hail",
    99: "Thunderstorm with heavy hail",
  };

  return owmMap[n] ?? wmoMap[n] ?? "Unknown weather condition";
}
